export const RNDdepartment = {
    opticalGroup: "光学部",
    structureGroup: "结构部",
    electronicGroup: "电子部",
};
